module.exports = __webpack_public_path__ + "img/avatar1.24f49720.png";